import Fixture from '~/components/atoms/Fixture/Fixture'
import { Col, Grid, Row } from '~/components/atoms/Grid'
import type { LinkProps } from '~/components/links'
import { resolveLink } from '~/components/serializers'
import { ComponentTheme } from '~/components/themes'
import { longDateFormat } from '~/utils/formatDate'

import Button, { ButtonVariants } from '../Button/Button'
import Container from '../Container/Container'
import { Icon } from '../Icon/Icon'
import Text, { TextSizes } from '../Text/Text'

import styles from './DocumentDownloadList.module.css'

type DataProps = {
  title: string
  date: string
  link: LinkProps
}

export interface DocumentDownloadListProps {
  data: DataProps[]
  title: string
  theme?: ComponentTheme
  verticalPadding?: boolean
  noPaddingBottom?: boolean
  testID?: string
}

export default function DocumentDownloadList({
  data,
  title,
  theme = ComponentTheme.primary,
  verticalPadding,
  noPaddingBottom,
  testID,
}: DocumentDownloadListProps) {
  const renderItem = (item: DataProps, idx: number) => {
    return (
      <li key={`${item.date}-${idx}`} className={styles.item}>
        <Grid>
          <Row>
            <Col variant="col-1/4--md">
              <Text size={TextSizes.bodyMed} className={styles.date}>
                {longDateFormat(item.date)}
              </Text>
            </Col>
            <Col variant="col-1/2--md">
              <Text
                size={TextSizes.bodyMed}
                Tag="h3"
                className={styles.itemTitle}
              >
                {item.title}
              </Text>
            </Col>
            <Col variant="col-1/4--md">
              <Button
                variant={ButtonVariants.secondaryDark}
                link={resolveLink(item.link)}
                iconLeft={<Icon type="Download" />}
                inline={true}
              >
                {item.link.text}
              </Button>
            </Col>
          </Row>
        </Grid>
      </li>
    )
  }

  return data ? (
    <Fixture
      theme={theme}
      verticalPadding={verticalPadding}
      noPaddingBottom={noPaddingBottom}
    >
      <Container>
        <div className={styles.base} data-testid={testID}>
          <Text
            Tag="h3"
            size={TextSizes.primaryTitleLrg}
            className={styles.title}
          >
            {title}
          </Text>
          <ul>{data.map((item, idx) => renderItem(item, idx))}</ul>
        </div>
      </Container>
    </Fixture>
  ) : (
    <></>
  )
}
